// extracted by mini-css-extract-plugin
export default {"answerButton":"answer-button_answerButton__wTj2q","answerButtonContent":"answer-button_answerButtonContent__iSMl0"};